import React from 'react'
import {useRecoilState} from 'recoil'
import {InputBase} from "../../common";
import {createAlbumFormState} from "./atoms";


type Props = {
    type: string
    name: string
    label: string
    placeholder: string
}

const Input: React.FC<Props> = ({type, name, placeholder, label}: Props) => {
    const [state, setState] = useRecoilState(createAlbumFormState)

    return (
        <div className={'label_input_wrapper'}>
            <label style={{color: 'white'}}>
                {label}
            </label>
            <InputBase
                className={'form_input'}
                type={type}
                name={name}
                placeholder={placeholder}
                state={state}
                setState={setState}
            />
        </div>
    )
}

export default Input
